<div id="main-container" class="col-md-4 gradientBg">
  <h1 class="eventsTitle">{{ mainTitle }}</h1>
</div>

@for (text of texts; track text) {
  <div id="questionLists" class="col-md-10 mt-5">
    <div class="row">
      <div class="col-sm-12 col-lg-4 pb-3">
        <a
          href="https://web.cvent.com/event/5b61662e-684a-4feb-9081-d92e30aa35c5/summary"
          target="_blank"
          alt="Registration Link"
          >
          <div
            id="CABusinessPolicySummit"
            alt="Image of CA Business Policy Summit Flyer"
          ></div>
        </a>
      </div>
      <div class="col-md-8 textBody">
        <h2>{{ text.title }}</h2>
        <p>
          {{ text.text }}
        </p>
        <p>
          {{ text.text2 }}
        </p>
      </div>
    </div>
  </div>
}
